module.exports = __webpack_public_path__ + "static/img/0007.7a637ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/0007.png
// module id = +Idm
// module chunks = 1